import { Inject, Injectable, Optional } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PRESS_NEWS_DEBOUNCE_TIME } from '@shared/tokens';
import { EMPTY, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';
import {
  ActionTypes,
  AddPressNewsToListAction,
  GetListOfPressNews,
  GetPressNewsById,
  SetPressNewsDetail
} from './press-news.actions';
import { PressNewsListModel, PressNewsModel } from './press-news.interface';
import { PressNewsService } from './press-news.service';

@Injectable()
export class PressNewsEffect {
  loadPressNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetListOfPressNews>(ActionTypes.GET_LIST_OF_PRESS_NEWS),
      debounceTime(this.pressNewsDebounceTime),
      switchMap((data: any) => {
        const eventId = data.payload;
        return this.pressNewsService.getPressNewsList(eventId).pipe(
          map((pressNewsList: PressNewsListModel[]) => new AddPressNewsToListAction(pressNewsList)),
          catchError(() => of(new AddPressNewsToListAction([])))
        );
      })
    )
  );

  loadPressNewsByID$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetPressNewsById>(ActionTypes.GET_PRESS_NEWS_BY_ID),
      debounceTime(this.pressNewsDebounceTime),
      switchMap((data: any) => {
        const eventId = data.payload;
        if (!eventId) {
          return EMPTY;
        }

        return this.pressNewsService.getPressNews(eventId).pipe(
          map((pressNewsById: PressNewsModel) => new SetPressNewsDetail(pressNewsById)),
          catchError(() => of(new SetPressNewsDetail(null)))
        );
      })
    )
  );

  constructor(
    @Optional() @Inject(PRESS_NEWS_DEBOUNCE_TIME) private pressNewsDebounceTime: number,
    private actions$: Actions,
    private pressNewsService: PressNewsService
  ) {}
}
